import {
  Box,
  Button,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Tab,
  TabList,
  Tabs,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import "common/assets/css/action-navbar.css";
import { constant } from "common/constant";
import { ListIcon } from "common/assets/svg/ListIcon";
import { TableIcon } from "common/assets/svg/TableIcon";
import { globalStyles } from "common/theme/styles";
import AutoCompleteSearch from "../autoComplete/AutoComplete";
import OutlinedIconBtn from "../customButtons/OutlinedIconBtn";
import filterIcon from "common/assets/img/filterIcon.png";
import { useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import CustomSearchInput from "../search/search";
import moment from "moment";
import { feedbackConstants } from "common/constant";
const ActionNavbar = (props) => {
  const {
    title,
    onCreateClickHandler,
    isCreateBtnVisible,
    showActionDropdown = true,
    selectedValues,
    handleExportLeads,
    setManageColumns,
    setIsImport,
    ManageGrid,
    handleTabChange,
    filterSelectOption,
    onFilterSelect,
    actionOptions,
    handleActionSelect,
    isCreatePage = false,
    listViewHandle = true,
    kanbanViewHandle = false,
    currentView,

    // props for search
    setSearchedDataOut,
    setSearchboxOutside,
    searchboxOutside,
    allData,
    dataColumn,
    AdvanceSearch,
    searchDisplay,
    setSearchDisplay,
    setGetTagValuesOutside,
    state,
    tableCustomFields,
    searchedDataOut,
    tableData,

    setFinalSearchedData = () => {},
    isKanban = false,
    source = "",
    handleSearchChange,
    searchbox,
    setSearchbox,
    showInlineTitle = false,
    inlineTitle,
  } = props;
  const colors = globalStyles.colors;
  const location = useLocation();
  const currentPath = location.pathname;
  useEffect(() => {
    document.body.classList.remove("openFilter");
  }, [location]);

  const [selectedView, setSelectedView] = useState(constant.selectView);

  // states for search
  const [displaySearchData, setDisplaySearchData] = useState(false);
  const [searchedData, setSearchedData] = useState([]);
  const columns = useMemo(() => dataColumn, [dataColumn]);

  const [advaceSearch, setAdvaceSearch] = useState(false);
  const [searchValue, setSearchValue] = useState({});

  // func for search
  const data = useMemo(
    () =>
      (AdvanceSearch ? searchDisplay : displaySearchData)
        ? AdvanceSearch
          ? searchedDataOut
          : searchedData
        : tableData,
    [
      (AdvanceSearch ? searchDisplay : displaySearchData)
        ? AdvanceSearch
          ? searchedDataOut
          : searchedData
        : tableData,
    ]
  );

  const handleSearch = (results) => {
    AdvanceSearch ? setSearchedDataOut(results) : setSearchedData(results);
  };

  useEffect(() => {
    // if (searchedData?.length > 0) {

    setFinalSearchedData(searchedData);
    // }
  }, [searchedData]);

  const [getTagValues, setGetTagValues] = useState(
    props.getTagValuesOutSide ? props.getTagValuesOutSide : []
  );
  const [gopageValue, setGopageValue] = useState();

  const handleAdvanceSearch = (values) => {
    setSearchValue(values);

    const customSearchFields =
      isKanban && source === "deals"
        ? ["amount", "closeDate", "dealName"]
        : tableCustomFields.map((f) => f.name);

    const searchResult = allData?.filter((item) => {
      return tableCustomFields.every((field) => {
        if (!customSearchFields.includes(field.name)) {
          return true;
        }

        const fieldValue = values[field.name];
        const itemValue = item[field.name];

        if (field.type === "select") {
          return !fieldValue || itemValue === fieldValue;
        } else if (field.type === "number") {
          return (
            [null, undefined, ""].includes(fieldValue) ||
            (itemValue !== undefined &&
              itemValue.toString().includes(fieldValue.toString()))
          );
        } else if (field.type === "date") {
          const fromDate = values[`from${field.name}`];
          const toDate = values[`to${field.name}`];

          if (!fromDate && !toDate) {
            return true;
          }

          const timeItemDate = new Date(itemValue);
          const timeMomentDate = moment(timeItemDate).format("YYYY-MM-DD");

          return (
            (!fromDate || timeMomentDate >= fromDate) &&
            (!toDate || timeMomentDate <= toDate)
          );
        } else {
          return (
            !fieldValue ||
            itemValue?.toLowerCase()?.includes(fieldValue?.toLowerCase())
          );
        }
      });
    });

    const getValue = tableCustomFields.reduce((result, field) => {
      if (field.type === "date") {
        const fromDate = values[`from${field.name}`];
        const toDate = values[`to${field.name}`];

        if (fromDate || toDate) {
          result.push({
            name: [`from${field.name}`, `to${field.name}`],
            value: `From: ${fromDate} To: ${toDate}`,
          });
        }
      } else if (values[field.name]) {
        result.push({
          name: [field.name],
          value: values[field.name],
        });
      }

      return result;
    }, []);

    setGetTagValues(getValue);
    setSearchedData(searchResult);
    setDisplaySearchData(true);
    setAdvaceSearch(false);
    if (setSearchbox) {
      setSearchbox("");
    }
  };

  useEffect(() => {
    if (allData && tableCustomFields) {
      allData?.forEach((item) => {
        tableCustomFields?.forEach((field) => {
          const itemValue = item[field.name];
        });
      });
    }
  }, [allData, tableCustomFields]);

  const handleRemove = (name) => {
    const filter = (props.getTagValuesOutSide || [])
      .concat(getTagValues || [])
      .filter((item) => {
        if (Array.isArray(name?.name)) {
          return name.name?.toString() !== item.name?.toString();
        }
      });
    let updatedSearchValue = { ...searchValue };
    for (let key in updatedSearchValue) {
      if (updatedSearchValue.hasOwnProperty(key)) {
        if (name.name.includes(key)) {
          delete updatedSearchValue[key];
        }
        if (updatedSearchValue[key] === "") {
          delete updatedSearchValue[key];
        }
      }
    }

    handleAdvanceSearch(updatedSearchValue);
    setGetTagValues(filter);
    if (filter?.length === 0) {
      handleClear();
    }
  };

  const handleClear = () => {
    AdvanceSearch
      ? props?.setSearchDisplay(false)
      : setDisplaySearchData(false);
    if (searchboxOutside) {
      setSearchboxOutside("");
    } else {
      setSearchbox("");
    }
    setGetTagValues([]);
    if (props?.getTagValuesOutSide) {
      setGetTagValuesOutside([]);
    }
    setGopageValue(1);
  };

  const findStatus = () => {
    const searchResult = allData?.filter(
      (item) =>
        !state ||
        (item?.status &&
          item?.status?.toLowerCase().includes(state?.toLowerCase()))
    );
    let getValue = [state || undefined].filter((value) => value);
    setGetTagValues(getValue);
    AdvanceSearch
      ? setSearchedDataOut && setSearchedDataOut(searchResult)
      : setSearchedData && setSearchedData(searchResult);
    AdvanceSearch
      ? setSearchDisplay && setSearchDisplay(true)
      : setDisplaySearchData && setDisplaySearchData(searchResult);
    setDisplaySearchData(true);
    setAdvaceSearch(false);
  };
  useEffect(() => {
    state && findStatus();
  }, [state, allData]);

  useEffect(() => {
    AdvanceSearch
      ? setSearchedDataOut && setSearchedDataOut(data)
      : setSearchedData && setSearchedData(data);
  }, []);

  return (
    <>
      <Flex
        hidden={isCreatePage}
        justify="space-between" align="center" className="topActionBar">
        {isCreatePage ? (
          <>
            {/* <Box className="showCursor">
              <Box className="disabledView">
                <OutlinedIconBtn
                  borderColor={colors.borderColor}
                  color={colors.text["200"]}
                  rightIcon={
                    <ChevronDownIcon
                      fontSize={"xl"}
                      color={colors.text["200"]}
                    />
                  }
                  title={constant.chooseJobTemp}
                />
              </Box>
            </Box> */}
          </>
        ) : (
          <>
            <Flex gap={"16px"}>
              {showInlineTitle && (
                <Box>
                  <Box
                    fontSize={{ base: "22px", md: "24px" }}
                    fontWeight="700"
                    lineHeight="1.2"
                    color={colors.pageTitleColor}
                  >
                    {inlineTitle || title}
                  </Box>
                </Box>
              )}
              {/* <OutlinedIconBtn
                onClick={() => document.body.classList.toggle("openFilter")}
                leftIcon={<Image h={"16px"} w={"16px"} src={filterIcon} />}
                title={constant.filter}
              /> */}
              {/* <Box className="">
                <AutoCompleteSearch
                  onFilterSelect={onFilterSelect}
                  options={filterSelectOption}
                />
              </Box>
              {currentView === constant.tableView && (
                <Box display={"flex"} alignItems={"center"}>
                  <CustomSearchInput
                    setSearchbox={
                      setSearchboxOutside ? setSearchboxOutside : setSearchbox
                    }
                    setDisplaySearchData={
                      setSearchboxOutside
                        ? props.setSearchDisplay
                        : setDisplaySearchData
                    }
                    searchbox={searchboxOutside ? searchboxOutside : searchbox}
                    allData={allData}
                    dataColumn={columns}
                    onSearch={handleSearchChange}
                    setGetTagValues={
                      props.setGetTagValuesOutside
                        ? props.setGetTagValuesOutside
                        : setGetTagValues
                    }
                    setGopageValue={setGopageValue}
                    isKanban={true}
                    source={source}
                    handleSearchChange={handleSearchChange}
                  />
                </Box>
              )} */}
            </Flex>
            <Flex gap={"20px"}>
              <Flex alignItems={"center"} gap={"8px"}>
                <Flex pt={"12px"} className="actionBarTabContainer">
                  <Flex>
                    {isCreateBtnVisible && title !== feedbackConstants.createFeedback && (
                      <Button
                        size="sm"
                        variant="brand"
                        className="navCreateBtn"
                        onClick={() => onCreateClickHandler && onCreateClickHandler()}
                      >
                        {title === "New Password" ? (
                          <>
                            {constant.add} {title}
                          </>
                        ) : (
                          <>{constant.create}</>
                        )}
                      </Button>
                    )}
                  </Flex>
                  {/* {ManageGrid !== false && (
                    <Menu className="relativeExportSelect" isLazy>
                      <MenuButton
                        className={`exportSelect ${
                          !isCreateBtnVisible ? "rounded" : ""
                        }`}
                      >
                        <ChevronDownIcon
                          fontSize={"2xl"}
                          strokeWidth={"1px"}
                          color={colors.white}
                        />
                      </MenuButton>
                      <MenuList
                        className="exportSelectList"
                        minW={"fit-content"}
                        zIndex={2}
                      >
                        <MenuItem
                          onClick={() => setManageColumns(true)}
                          width={"165px"}
                        >
                          {constant.manageColumns}
                        </MenuItem>
                        {typeof setIsImport === "function" && (
                          <MenuItem
                            width={"165px"}
                            onClick={() => setIsImport(true)}
                          >
                            {constant.import} {title}
                          </MenuItem>
                        )}
                        <MenuItem
                          width={"165px"}
                          onClick={() => handleExportLeads("csv")}
                        >
                          {selectedValues && selectedValues.length > 0
                            ? constant.exportSelectedDataAsCSV
                            : constant.exportAsCSV}
                        </MenuItem>
                        <MenuItem
                          width={"165px"}
                          onClick={() => handleExportLeads("xlsx")}
                        >
                          {selectedValues && selectedValues.length > 0
                            ? constant.exportSelectedDataAsExcel
                            : constant.exportAsExcel}
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  )} */}
                </Flex>

                {showActionDropdown && (
                  <Menu isLazy>
                    <MenuButton className="">
                      <OutlinedIconBtn
                        borderColor={colors.cta["100"]}
                        color={colors.cta["100"]}
                        rightIcon={
                          <ChevronDownIcon
                            fontSize={"xl"}
                            color={colors.cta["100"]}
                          />
                        }
                        title={constant.action}
                      />
                    </MenuButton>
                    <MenuList
                      className="exportSelectList"
                      minW={"fit-content"}
                      zIndex={2}
                    >
                      <MenuItem
                        onClick={() => setManageColumns(true)}
                        width={"165px"}
                      >
                        {constant.manageColumns}
                      </MenuItem>
                      {typeof setIsImport === "function" && (
                        <MenuItem
                          width={"165px"}
                          onClick={() => setIsImport(true)}
                        >
                          {constant.import} {title}
                        </MenuItem>
                      )}
                      <MenuItem
                        width={"165px"}
                        onClick={() => handleExportLeads("csv")}
                      >
                        {selectedValues && selectedValues.length > 0
                          ? constant.exportSelectedDataAsCSV
                          : constant.exportAsCSV}
                      </MenuItem>
                      <MenuItem
                        width={"165px"}
                        onClick={() => handleExportLeads("xlsx")}
                      >
                        {selectedValues && selectedValues.length > 0
                          ? constant.exportSelectedDataAsExcel
                          : constant.exportAsExcel}
                      </MenuItem>
                    </MenuList>
                  </Menu>
                )}
              </Flex>
            </Flex>
          </>
        )}
      </Flex>
    </>
  );
};

export default ActionNavbar;
